export enum RefreshType {
    Reload = 'reload',
    NoReload = 'noReload'
}
